"use client";

import { useEffect } from "react";
import BaseProductPage from "../../shared/product/base-product-page";
import StoreBox from "../store-box";
import ProductDetails from "./product-details";
import styles from "./index.module.css";
import SimilarProducts from "./similarProducts";
import ProductPageSkeleton from "./product-page-skeleton";

const ProductPage = (props) => {
  const productId = props.urlData?.product?.productId;

  useEffect(() => {
    if (!productId || typeof window === "undefined") return;

    let frame = null;
    const timers = [];

    const syncProductLayout = () => {
      window.scrollTo(0, 0);

      const header = document.querySelector("header");
      const headerHeight = header?.getBoundingClientRect?.().height || 0;
      const stickyOffset = Math.max(96, Math.ceil(headerHeight + 16));

      document.documentElement.style.setProperty(
        "--conveti-product-sticky-top",
        `${stickyOffset}px`,
      );
      window.dispatchEvent(new Event("resize"));
    };

    frame = requestAnimationFrame(() => {
      syncProductLayout();
      timers.push(window.setTimeout(syncProductLayout, 80));
      timers.push(window.setTimeout(syncProductLayout, 260));
    });

    return () => {
      if (frame) cancelAnimationFrame(frame);
      timers.forEach((timer) => window.clearTimeout(timer));
    };
  }, [productId]);

  return (
    <BaseProductPage
      {...props}
      StoreBox={StoreBox}
      ProductDetails={ProductDetails}
      SimilarProducts={SimilarProducts}
      ProductPageSkeleton={ProductPageSkeleton}
      styles={styles}
      productBreadcrumbClassName={styles.convetiProductBreadcrumb}
    />
  );
};

export default ProductPage;
